import { _ as _object_spread } from "@swc/helpers/_/_object_spread";
import { _ as _object_without_properties } from "@swc/helpers/_/_object_without_properties";
import React, { useContext } from 'react';
import { useTranslation } from 'react-i18next';
import { BiEventType } from '@wix/da-bi/pkg/constants';
import { MobileContext } from '@wix/da-react-context/pkg/MobileContext';
import { IconSize } from '@wix/da-ds/pkg/Icons/IconWrap';
import NetworkBarItem from '../NetworkBarItem';
const NetworkBarLink = (_param)=>{
    var { label, icon: Icon, iconElement, url, hasNewContent, showTooltip, isCollapsed } = _param, rest = _object_without_properties(_param, [
        "label",
        "icon",
        "iconElement",
        "url",
        "hasNewContent",
        "showTooltip",
        "isCollapsed"
    ]);
    const { t } = useTranslation();
    const isMobile = useContext(MobileContext);
    return /*#__PURE__*/ React.createElement(NetworkBarItem, _object_spread({
        url: url,
        tooltipContent: t(`networkBar.navItems.${label}.tooltip`),
        "aria-label": t(`networkBar.navItems.${label}`),
        icon: iconElement ? iconElement : Icon && /*#__PURE__*/ React.createElement(Icon, {
            disableDefaultColors: true,
            size: IconSize.MEDIUM
        }),
        biData: {
            evid: BiEventType.NETWORK_BAR_NAV_CLICK,
            sectionname: label,
            indicator: hasNewContent ? 1 : 0,
            is_expanded: isCollapsed ? 0 : 1
        },
        menuBiData: {
            evid: BiEventType.NETWORK_BAR_3DOTS_OPEN,
            sectionname: label,
            indicator: hasNewContent ? 1 : 0
        },
        hasNewContent: hasNewContent,
        isCollapsed: isCollapsed,
        isTaller: isMobile
    }, rest), t(`networkBar.navItems.${label}`));
};
NetworkBarLink.displayName = 'NetworkBarLink';
export default NetworkBarLink;
